/**
 * Коды баннеров, зашитых во фронте: в выдаче `/api/content/announcements` их
 * нет, опознать их можно только по коду.
 *
 * Реестра кодов на бэкенде намеренно нет — иначе каждый новый промо-баннер
 * требовал бы выкладки. Поэтому список кодов это контракт, и он живёт здесь.
 * Опечатка не даст ошибки: она молча заведёт в отчёте лишний баннер.
 * Переименование кода разорвёт историю метрик пополам, поэтому код задаётся
 * один раз и не меняется.
 *
 * Требования сервера: строчная латиница, цифры и `_`, первый символ — буква,
 * до 64 символов.
 */
export const BANNER_SPECIAL_CODES = {
  subscription: 'subscribe',
  'fortune-wheel': 'fortune_wheel',
  'flavor-constructor': 'foodpairing',
} as const

export type BannerSpecialType = keyof typeof BANNER_SPECIAL_CODES
